import { render } from "./aio-login-social-login.vue?vue&type=template&id=b5cc50cc&scoped=true"
import script from "./aio-login-social-login.vue?vue&type=script&lang=js"
export * from "./aio-login-social-login.vue?vue&type=script&lang=js"

import "./aio-login-social-login.vue?vue&type=style&index=0&id=b5cc50cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5cc50cc"]])

export default __exports__